import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import DataTable from "../../common/dataTable";
import PageBreadcrumb from "../../common/PageBreadcrumb/PageBreadcrumb";
import { useCapaAccess } from "./capaAccess";
import { fetchCapaEffectiveness } from "./capaService";
import "./CapaPages.scss";

const CapaEffectiveness = () => {
  const navigate = useNavigate();
  const { userData, canCapaMyWork } = useCapaAccess();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const r = await fetchCapaEffectiveness();
      if (!cancelled) setRows(r);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const columns = [
    { label: "CAPA no.", accessor: "CapaNo" },
    { label: "Review due", accessor: "ReviewDueDate", type: "date" },
    { label: "Owner", accessor: "OwnerName" },
    { label: "Criteria", accessor: "Criteria" },
    { label: "Status", accessor: "Status" },
  ];

  if (!userData) {
    return (
      <div className="d-flex justify-content-center p-5">
        <div className="spinner-border" role="status" />
      </div>
    );
  }
  if (!canCapaMyWork) return <Navigate to="/notification-center" replace />;

  return (
    <div className="capa-page">
      <PageBreadcrumb
        items={[
          { label: "Home", path: "/notification-center" },
          { label: "Effectiveness reviews" },
        ]}
        actions={[
          { icon: "fas fa-list", label: "CAPA list", onClick: () => navigate("/capa") },
        ]}
      />
      <DataTable data={rows} columns={columns} sortable={["ReviewDueDate"]} showToggle={true} />
    </div>
  );
};

export default CapaEffectiveness;
